import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function WorkshopFinalCTA() {
  return <section id="inscriere" className="py-24 lg:py-32 bg-[#4F2E7E] relative scroll-mt-24 overflow-hidden" data-id="element-2190">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/15 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-2191" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/10 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-2192" />

      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center" data-id="element-2193">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-2194">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-brand-gold/20 border border-brand-gold/40 text-brand-gold text-xs md:text-sm font-bold uppercase tracking-[0.25em] mb-8" data-id="element-2195">
            <Sparkles className="w-4 h-4" data-id="element-2196" />
            Locuri Limitate
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-6 text-balance" data-id="element-2197">
            Începutul transformării tale este la un click distanță
          </h2>
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-2198">
            Rezervă-ți locul acum. Vei primi linkul de Zoom pe email imediat
            după înscriere, plus reminder cu 24h și 1h înainte de workshop.
          </p>

          <a href="https://api.leadconnectorhq.com/widget/form/ixNeic40gOfHzGUPnS7D" target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-text font-heading font-bold text-xl md:text-2xl px-10 py-5 rounded-2xl hover:bg-white transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-2199">
            Înscrie-te Gratuit la Workshop
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-2200" />
          </a>

          <p className="mt-6 text-sm text-white/70" data-id="element-2201">
            Locurile sunt limitate de capacitatea Zoom. Înscrie-te acum ca să
            îți rezervi locul.
          </p>
        </motion.div>
      </div>
    </section>;
}